import(/* webpackMode: "eager" */ "/home/runner/work/onecrm-widgets/onecrm-widgets/src/app/page.tsx");
